import React, { useEffect, useRef } from 'react';
import { StyledRoomsAndEventSpace } from '../RoomsAndEventSpace.styles';
import { RoomsAndEventSpaceProps, Variant } from '../RoomsAndEventSpace.types';
import { AttendeesStepper, RoomsStepper } from '../../index';
import { useRoomsAndEventSpace } from '../useRoomsAndEventSpace';

export const MobileRoomsAndEventSpace = ({
  labels,
  variant,
  onChange,
  value,
  fieldErrors,
}: RoomsAndEventSpaceProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { guestRooms, attendees, guestRoomsAndEventSpace } = labels;

  const {
    roomsAndEventSpace,
    increaseRooms,
    decreaseRooms,
    increaseAttendees,
    decreaseAttendees,
    inputRoomHandler,
    inputAttendeesHandler,
  } = useRoomsAndEventSpace(value, onChange, variant, false);

  const showRooms = variant === Variant.ROOMS || variant === Variant.ROOMSANDEVENTSPACE;
  const showAttendees = variant === Variant.EVENTSPACE || variant === Variant.ROOMSANDEVENTSPACE;

  useEffect(() => {
    const firstInput = containerRef.current?.querySelector<HTMLInputElement>(
      '.rooms-eventspace-container input:not([type="hidden"]):not([disabled])'
    );

    firstInput?.focus();
  }, []);

  return (
    <StyledRoomsAndEventSpace
      data-testid="groups-RoomsAndEventSpace-mobile"
      data-component-name="m-groups-RoomsAndEventSpaceMobile"
      ref={containerRef}
    >
      <div className="rooms-eventspace-container mobile-container">
        {showRooms && <div className="t-font-m mb-2">{guestRoomsAndEventSpace.message}</div>}

        {showRooms && (
          <RoomsStepper
            labels={guestRooms}
            value={roomsAndEventSpace.rooms}
            onIncrement={increaseRooms}
            onDecrement={decreaseRooms}
            onInputChange={inputRoomHandler}
            fieldError={fieldErrors?.rooms}
          />
        )}

        {showAttendees && (
          <AttendeesStepper
            labels={attendees}
            value={roomsAndEventSpace.eventAttendees}
            onIncrement={increaseAttendees}
            onDecrement={decreaseAttendees}
            onInputChange={inputAttendeesHandler}
            fieldError={fieldErrors?.attendees}
          />
        )}
      </div>
    </StyledRoomsAndEventSpace>
  );
};
